const ordenarClaves = (valor) => {
  if (Array.isArray(valor)) return valor.map(ordenarClaves);

  if (valor === null || typeof valor !== "object") return valor;

  const prototipo = Object.getPrototypeOf(valor);
  if (prototipo !== Object.prototype && prototipo !== null) return valor;

  return Object.keys(valor)
    .sort()
    .reduce((resultado, clave) => {
      resultado[clave] = ordenarClaves(valor[clave]);
      return resultado;
    }, {});
};

export const crearFirmaFiltros = (filtros = {}) =>
  JSON.stringify(ordenarClaves(filtros));

export const coincideConFiltrosSincronizados = ({
  filtros,
  firmaSincronizada,
}) =>
  firmaSincronizada !== null &&
  firmaSincronizada === crearFirmaFiltros(filtros);
